<template>
    <div :class="iconClass" :id="iconId">
        <a class="instagram-icon" :href="iconMedia" target="_blank" v-show="iconKey==2 || iconKey==6">
            <icon-base box="0 0 40 40" width="48" height="48" icon-name="Instagram">
                <icon-instagram />
            </icon-base>
        </a>
        <a class="linkedin-icon" :href="iconMedia" target="_blank" v-show="iconKey == 1 || iconKey == 3 || iconKey == 4 || iconKey == 5 || iconKey == 7 || iconKey == 8">
            <icon-base box="0 0 45 45" width="45" height="45" icon-name="LinkedIn">
            <icon-linkedin />
            </icon-base>
        </a>
    </div>
</template>

<style>
	.linkedin-icon:hover svg path{
		stroke: #2abecc !important;
		fill: #2abecc !important;
	}
	.instagram-icon:hover svg path{
		stroke: #2abecc !important;
	}
</style>

<script>
import IconBase from './IconBase'
import IconLinkedin from './icons/IconLinkedin'
import IconInstagram from './icons/IconInstagram'
export default {
	components: {
		IconBase,
		IconLinkedin,
		IconInstagram
	},
	props: {
        iconKey:{
			type: Number
		},
		iconId:{
			type: String
		},
		iconClass:{
			type: String
        },
        iconMedia:{
			type: String
		}
	}    
}
</script>